/* start collection description */
(function () {
  function initCollectionDescription() {
    document
      .querySelectorAll('.a2-collection-description__toggle')
      .forEach(function (button) {

        if (button.dataset.a2Initialized === 'true') {
          return;
        }

        button.dataset.a2Initialized = 'true';

        button.addEventListener('click', function () {
          const wrapper = button.closest('.a2-collection-description');

          if (!wrapper) return;

          const expanded = wrapper.classList.toggle('is-expanded');

          button.setAttribute(
            'aria-expanded',
            expanded ? 'true' : 'false'
          );
        });
      });
  }

  // Normal page load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCollectionDescription);
  } else {
    initCollectionDescription();
  }

  // Shopify Theme Editor / dynamic section reload
  document.addEventListener('shopify:section:load', initCollectionDescription);
})();
/* end collection description */

/* start product page review tab open */
document.addEventListener('DOMContentLoaded', function () {
  var reviewLink = document.querySelector('.custom-product-rating__reviews');

  if (reviewLink) {
    reviewLink.addEventListener('click', function (e) {
      e.preventDefault();

      var targetId = this.getAttribute('href').replace('#', '');
      var reviewTab = document.getElementById(targetId);

      if (reviewTab) {
        // Trigger the tab's own click handler so the panel actually switches
        reviewTab.click();

        // Give the tab-panel component a moment to render/open, then scroll
        setTimeout(function () {
          reviewTab.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }, 100);
      }
    });
  }
});
/* end product page review tab open */